import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import { selectTrainersData } from "../../../redux/reducers/trainerDataSlice";
import { fetchGymData, fetchTrainersData } from "../../../data/APIs";
import "../../../styles/diet/diet.css";
import {
  addImportMember,
  createFetchPlans,
  uploadImage,
} from "../../../redux/reducers/postApiSlice";
import { valiateImportForm } from "../common/Validations";
import { toast } from "react-toastify";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const ImportMemForm = ({ setModal, decryptedText, callFunction }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.postApi);
  const trainersData = useSelector(selectTrainersData);
  const gymData = useSelector(selectGymData);

  const isAdmin = decryptedText?.account_type === "admin";

  const iniFormValues = [
    {
      memName: "",
      memMobile: "",
      memEmail: "",
      selPlan: "",
      planPrice: "",
      startDate: "",
      endDate: "",
      taxAmount: "",
      choosedFile: null,
      convertedFile: "",
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const initialAllPansData = {
    allPlansData: [],
    allPlansDropdownData: [],
  };
  const [allPlans, setAllPlans] = useState(initialAllPansData);
  const [selectedGymValue, setSelectedGymValue] = useState(
    !isAdmin
      ? {
          label: decryptedText?.gym_name,
          value:
            decryptedText?.gym_id ||
            decryptedText?.user_id ||
            decryptedText?.uid,
        }
      : ""
  );
  const [selTrainer, setSelTrainer] = useState("");

  const closeModal = () => {
    setModal(false);
  };

  const addFormInput = (e) => {
    e.preventDefault();

    setFormValues([
      ...formValues,
      {
        memName: "",
        memMobile: "",
        memEmail: "",
        selPlan: "",
        planPrice: "",
        startDate: "",
        endDate: "",
        taxAmount: "",
      },
    ]);
  };

  const removeFormInput = (e, index) => {
    e.preventDefault();

    const newFormValues = [...formValues];
    newFormValues.splice(index, 1);
    setFormValues(newFormValues);
  };

  const onChangeInput = (e, index, inputName) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      const newFormValues = [...formValues];
      newFormValues[index][name] = file;
      setFormValues(newFormValues);
      handleUploadImage(file, decryptedText?.token, index);
    } else {
      const newFormValues = [...formValues];
      newFormValues[index][name] = value;

      if (inputName === "startDate") {
        const selectedPlan = newFormValues[index].selPlan;
        const startDate = new Date(value);
        let endDate = new Date(startDate);

        if (selectedPlan && selectedPlan.info && selectedPlan.info.duration) {
          const planDuration = parseInt(selectedPlan.info.duration);
          endDate.setDate(startDate.getDate() + planDuration);
        }

        newFormValues[index].endDate = endDate.toISOString().split("T")[0];
      } else if (inputName === "planPrice") {
        const selectedPlan = newFormValues[index].selPlan;
        const planPrice = parseFloat(value);
        const taxPercentage = selectedPlan?.info?.tax_percentage || 0;
        const taxAmount = (planPrice * taxPercentage) / 100;
        newFormValues[index].taxAmount = taxAmount.toFixed(2);
      }

      setFormValues(newFormValues);
    }
  };

  const onChangeDropdown = (value, name, index) => {
    setFormValues((prevFormValues) => {
      const newFormValues = [...prevFormValues];
      newFormValues[index] = {
        ...newFormValues[index],
        [name]: value,
        planPrice: value?.info?.plan_price || 0,
      };
      return newFormValues;
    });
  };

  const handleUploadImage = async (file, TOKEN, index) => {
    setIsSubmit(false);
    try {
      const actionResult = dispatch(uploadImage({ file, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        setFormValues((prevs) => {
          const prevFormValues = [...prevs];
          const updatedForm = { ...prevFormValues[index] };

          updatedForm.convertedFile = result?.payload?.image_url || "";

          prevFormValues[index] = updatedForm;
          return prevFormValues;
        });
        // toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreateNewMeal ERROR => ", error);
    }
  };

  const onSubmit = () => {
    setIsSubmit(true);
    setFormErrors(valiateImportForm(formValues, selTrainer));
  };

  const handleCreateFetchPlans = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(createFetchPlans({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        setAllPlans({ ...allPlans, allPlansData: result.payload.data });
      } else {
        const errorMessage = result?.error?.message;
        console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleCreateFetchPlans ERROR => ", error);
    }
  };

  const handleAddImportMember = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(addImportMember({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAddImportMember ERROR => ", error);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchGymData(decryptedText?.token));
    }
  }, []);

  useEffect(() => {
    // const gymQP = decryptedText?.gym_id ? `${decryptedText.gym_id}` : "";
    const gymID = selectedGymValue?.value || "";
    dispatch(fetchTrainersData(decryptedText?.token, gymID));

    handleCreateFetchPlans(
      {
        gym_id: gymID || "",
      },
      decryptedText?.token
    );
  }, [selectedGymValue]);

  useEffect(() => {
    const allPlansDropdownDataFind = allPlans.allPlansData.map((plan) => {
      return {
        label: `${plan.plan_name}/${plan.duration}Days`,
        value: plan.plan_uid,
        info: plan,
      };
    });

    setAllPlans({
      ...allPlans,
      allPlansDropdownData: allPlansDropdownDataFind,
    });
  }, [allPlans.allPlansData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      setIsSubmit(false);

      const usersData = formValues.map((formValue) => ({
        name: formValue.memName,
        mobile: formValue.memMobile,
        email: formValue.memEmail,
        password: "password",
        price: formValue.planPrice,
        transaction_id: "import_member",
        tax_percentage: formValue.selPlan?.info?.tax_percentage || 0,
        tax_amount: formValue.taxAmount || 0,
        start_date: formValue.startDate,
        end_date: formValue.endDate,
        plan_id: formValue.selPlan?.value || "",
        remarks: "Import Member",
        type: "regular",
        plan_duration: formValue.selPlan?.info?.duration || "",
        trainer: selTrainer?.value,
        image: formValue.convertedFile,
      }));

      const mobiles = formValues
        .map((formValue) => formValue.memMobile)
        .join(",");

      const userData = {
        trainer_id: selTrainer?.value || "",
        gym_id: selectedGymValue?.value || "",
        mobiles: mobiles,
        users: usersData,
      };

      const handleConfirm = async () => {
        handleAddImportMember(userData, decryptedText?.token);
      };

      showConfirmAlert(
        handleConfirm,
        "Are you sure!",
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    if (!decryptedText) {
      navigate("/open-access");
    }
  }, [decryptedText]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
      <CommonHeadingNBtns
        title="Import Member"
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={loading}
      />

      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          {isAdmin && (
            <div className="formInputBox">
              <label htmlFor="selectedGymValue" className="formInputLabel">
                gym <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedGymValue ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={gymData?.length > 0 ? gymData : []}
                  selectedOption={selectedGymValue}
                  setSelectedOption={(selectedValue) => {
                    setSelectedGymValue(selectedValue);
                    setSelTrainer("");
                    setFormValues((prevValues) =>
                      prevValues.map((formValue) => ({
                        ...formValue,
                        selPlan: "",
                        planPrice: "",
                        taxAmount: "",
                      }))
                    );
                  }}
                  name="Gym"
                />
              </div>
            </div>
          )}

          <div className="formInputBox span2">
            <label htmlFor="selTrainer" className="formInputLabel">
              Trainer <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selTrainer ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={trainersData?.length > 0 ? trainersData : []}
                selectedOption={selTrainer}
                setSelectedOption={(selectedValue) =>
                  setSelTrainer(selectedValue)
                }
                name="Trainer"
              />
            </div>
          </div>
        </div>

        {formValues.map((formInput, index) => (
          <div key={index} className="formInputsGrid threeGridSystem">
            <div className="formInputBox">
              <label htmlFor={`memName${index}`} className={`formInputLabel `}>
                Member Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Name"
                className={`formInput ${
                  formErrors[index]?.memName ? "formError" : ""
                }`}
                name="memName"
                value={formInput.memName}
                onChange={(e) => onChangeInput(e, index)}
              />
            </div>
            <div className="formInputBox">
              <label
                htmlFor={`memMobile${index}`}
                className={`formInputLabel `}
              >
                Member Mobile <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Number"
                className={`formInput ${
                  formErrors[index]?.memMobile ? "formError" : ""
                }`}
                name="memMobile"
                value={formInput.memMobile}
                onChange={(e) => onChangeInput(e, index)}
              />
            </div>
            <div className="formInputBox">
              <label
                htmlFor={`memEmail ${index}`}
                className={`formInputLabel `}
              >
                Member Email <span className="required">*</span>
              </label>

              <input
                type="email"
                placeholder="Enter Email"
                className={`formInput ${
                  formErrors[index]?.memEmail ? "formError" : ""
                }`}
                name="memEmail"
                value={formInput.memEmail}
                onChange={(e) => onChangeInput(e, index)}
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="selPlan" className={`formInputLabel `}>
                Plan <span className="required">*</span>
              </label>
              <div
                className={`commonWrapper ${
                  formErrors[index]?.selPlan ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={allPlans.allPlansDropdownData}
                  selectedOption={formValues[index].selPlan}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selPlan", index)
                  }
                  name="Plan"
                />
              </div>
            </div>
            <div className="formInputBox">
              <label htmlFor="planPrice" className={`formInputLabel `}>
                Plan Price <span className="required">*</span>
              </label>
              <input
                type="number"
                placeholder="Enter Price"
                className={`formInput ${
                  formErrors[index]?.planPrice ? "formError" : ""
                }`}
                name="planPrice"
                value={formValues[index].planPrice}
                onChange={(e) => onChangeInput(e, index, "planPrice")}
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="startDate" className={`formInputLabel `}>
                Start Date <span className="required">*</span>
              </label>
              <input
                type="date"
                className={`formInput ${
                  formErrors[index]?.startDate ? "formError" : ""
                } ${formValues[index].startDate ? "date-has-value" : ""}`}
                name="startDate"
                value={formValues[index].startDate}
                onChange={(e) => onChangeInput(e, index, "startDate")}
              />
            </div>
            <div className="formInputBox span2">
              <label htmlFor="choosedFile" className={`formInputLabel `}>
                Upload File
              </label>

              <div
                className="custom-file"
                style={{
                  background: "#fff",
                  padding: "20px",
                  height: "150px",
                  border: "1px solid gray",
                }}
              >
                <div className="choosefileBtn">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="choosedFile"
                    name="choosedFile"
                    aria-describedby="inputGroupFileAddon01"
                    accept="*"
                    file={formValues.choosedFile}
                    onChange={(e) => onChangeInput(e, index)}
                  />
                </div>
                <label
                  className="custom-file-label"
                  htmlFor="choosedFile"
                  style={{
                    marginTop: "15px",
                  }}
                >
                  Image/File
                </label>
              </div>
            </div>

            <div className="formInputBox span3">
              <div className="add-remove-btns">
                {formValues.length !== 1 &&
                formValues[formValues.length - 1] ? (
                  <button
                    className="btn-action remove"
                    onClick={(e) => removeFormInput(e, index)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-dash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                    </svg>
                    Remove Member
                  </button>
                ) : null}
                {formValues.length === 0 || index === formValues.length - 1 ? (
                  <button
                    className="btn-action add"
                    onClick={(e) => addFormInput(e)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>
                    Add More Member
                  </button>
                ) : null}
              </div>
            </div>

            <div className="grayLine span3"></div>
          </div>
        ))}
      </form>
    </div>
  );
};

export default ImportMemForm;
